import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { E as d, S as _ } from "./icons.types-0722eef5.js";
function p({ title: t, titleId: n, size: l, width: a, height: c, extended: i = !1, ...s }) {
  const h = i ? d : _, o = l ? h[l] : a || h[i ? "s" : "l"], g = l ? h[l] : c || h[i ? "s" : "l"];
  return /* @__PURE__ */ e(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: o,
      height: g,
      "aria-labelledby": n,
      ...s,
      children: [
        t ? /* @__PURE__ */ r("title", { id: n, children: t }) : null,
        /* @__PURE__ */ r("g", { clipPath: "url(#Battery__Charging_svg__a)", children: /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M49.014 9H24.328v59.401h24.686V9Zm3.527-3.6L52.523 72H20.824l-.022-66.6h7.209V0h17.477v5.4h7.053Zm-7.327 31.078-10.964 15.2c-.846 1.074-2.578.366-2.419-.988l2.312-12.89h-4.838c-1.18 0-1.866-1.326-1.178-2.278l10.965-15.2c.846-1.074 2.577-.366 2.418.989L39.2 34.2h4.837c1.179 0 1.864 1.326 1.177 2.278Z"
          }
        ) }),
        /* @__PURE__ */ r("defs", { children: /* @__PURE__ */ r("clipPath", { id: "Battery__Charging_svg__a", children: /* @__PURE__ */ r(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  p as BatteryCharging
};
